// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"a465f753","787":"585434cb"}[chunkId] + ".chunk.js";
};